import React from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';

const Container = styled.div`
    width: 87.674%;
    max-width: 1000px;
    margin: 60px auto;
    color: #333;
    line-height: 1.8;

    ${mqMin('NARROW')} {
        width: 92.014%;
    }
`;

const Title = styled.h2`
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 40px;
    border-left: 5px solid var(--blue);
    padding-left: 15px;
`;

const Section = styled.div`
    margin-bottom: 40px;
`;

const SubHeading = styled.h3`
    font-size: 1.25rem;
    margin-top: 30px;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Paragraph = styled.p`
    margin: 10px 0;
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;

    th,
    td {
        border: 1px solid #ccc;
        padding: 10px;
        text-align: left;
        vertical-align: top;
    }

    th {
        background-color: #f0f0f0;
    }

    td:first-of-type {
        background-color: #f0f0f0;
    }
`;

const SecondStyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;

    th,
    td {
        border: 1px solid #ccc;
        padding: 10px;
        text-align: left;
        vertical-align: top;
    }

    th {
        background-color: #f0f0f0;
    }
`;

const Description = styled.p`
    margin-left: 10px;
`;

export const PrivacyPolicy = () => {
    return (
        <>
            <TopHeader />
            <Container>
                <Title>情報セキュリティ方針</Title>

                <Section>
                    <SubHeading>基本理念</SubHeading>
                    <Paragraph>
                        当社の事業の中で取り扱う、お客様の情報をはじめとする情報資産は、当社の経営基盤として極めて重要なものです。
                        <br />
                        漏洩、き損、滅失等のリスクから、情報資産を保護することの重要性を認識した役員や従業員を含めた、情報資産を扱う者が本方針を遵守し、情報資産の機密性、完全性、可用性といった情報セキュリティを維持するための活動を実践します。
                    </Paragraph>
                </Section>

                <Section>
                    <SubHeading>基本方針</SubHeading>
                    <Paragraph>
                        1.
                        情報資産を保護するために、情報セキュリティ方針ならびに、それにまつわる規程類を策定し、これに従って業務を行うとともに、情報セキュリティに関連する法令、規制その他の規範、及び、お客様との契約事項を遵守いたします。
                        <br />
                        2.
                        情報資産に対して存在する漏洩、き損、滅失等のリスクを分析、評価するための基準を明確にし、体系的なリスクアセスメント方法を確立するとともに、定期的にリスクアセスメントを実施いたします。また、その結果に基づき、必要かつ適切なセキュリティ対策を実施いたします。
                        <br />
                        3.
                        担当役員を中心とした情報セキュリティ体制を確立するとともに、情報セキュリティに関する権限および責任を明確にいたします。また、すべての従業者が、情報セキュリティの重要性を認識し、情報資産の適切な取り扱いを確実にするために、定期的に教育、訓練および啓発を行います。
                        <br />
                        4.
                        情報セキュリティポリシーの遵守状況及び情報資産の取扱いについて、定期的に点検及び監査を行い、発見された不備や改善項目については、速やかに是正処置を講じます。
                        <br />
                        5.
                        情報セキュリティ上のイベントやインシデントの発生に対する適切な処置を講じるとともに、万一それらが発生した場合に際して、あらかじめ、被害を最小限に留めるための対応手順を確立し、有事の際には、速やかに対応するとともに、適切な是正処置を講じます。また、特に、業務中断に関わるようなインシデントについては、その管理の枠組みを確立し、定期的に見直しを行うことにより、当社の事業継続を確実にいたします。
                        <br />
                        6.
                        基本理念を実現するための目標を定めた情報セキュリティマネジメントシステムを確立し、これを実行するとともに、継続的に見直し、改善を行います。
                    </Paragraph>
                </Section>
                <Title>プライバシーポリシー</Title>
                <Section>
                    <SubHeading>個人情報保護方針</SubHeading>
                    <Paragraph>
                        株式会社Sirbe（以下「当社」）は、当社事業である「MAny」の事業体として、社会に寄与する企業として個人情報の適切な取扱いに規範を示すべき立場にあるとの理念の下、個人情報を適切に取り扱うことの重要性を認識し、個人情報保護方針を定め、役員及び従業員が一体となってこれを遵守し、もって個人情報の保護及び個人の権利利益の保護に万全を尽くしてまいります。{' '}
                        <br />
                        <Description>
                            1.
                            個人情報を取得するに当たっては、その利用目的をできる限り特定し、その目的の達成に必要な限度において個人情報を取得致します。
                            <br />
                            2.
                            個人情報を、本人から直接、書面によって取得する場合には、弊社名、個人情報保護管理者名及び連絡先、利用目的等をお知らせした上で、必要な範囲で個人情報を取得致します。
                            <br />
                            3.
                            個人情報の利用は、本人が同意を与えた利用目的の範囲内で行います。また、目的外利用を行わないため、必要な対策を講じる手順を確立し、実施致します。
                            <br />
                            4. 保有する個人情報を適切な方法で管理し、本人の同意なしに第三者に開示・提供致しません。{' '}
                            <br />
                            5.
                            保有する個人情報を利用目的に応じた必要な範囲内において、正確、かつ、最新の状態で管理し、個人情報の漏えい、滅失又は毀損などのおそれに対して、合理的な安全対策を講じ、予防並びに是正に努めます。
                            <br />
                            6.
                            個人情報の処理を外部へ委託する場合は、漏えいや第三者への提供を行わない等を契約により義務づけ、委託先に対する適切な管理を実施致します。
                            <br />
                            7.
                            保有する個人情報についての苦情・相談は、弊社の問合せ窓口に連絡頂くことにより、これに対応致します。
                            <br />
                            8. 個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守致します。 <br />
                            9. 個人情報保護マネジメントシステムを定め、これを定期的に見直し、継続的に改善致します。
                        </Description>
                    </Paragraph>
                </Section>

                <Section>
                    <StyledTable>
                        <thead>
                            <tr>
                                <th colSpan={2}>個人情報に関する問い合わせ・開示等請求窓口</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>名称</td>
                                <td>株式会社Sirbe</td>
                            </tr>
                            <tr>
                                <td>所在地</td>
                                <td>東京都港区芝５－３６－４ 札ノ辻スクエア９階</td>
                            </tr>
                            <tr>
                                <td>個人情報保護管理者</td>
                                <td>杉澤 侑樹</td>
                            </tr>
                            <tr>
                                <td>連絡先</td>
                                <td>メール：info@ma-many.jp</td>
                            </tr>
                        </tbody>
                    </StyledTable>
                </Section>

                <Section>
                    <SubHeading>個人情報の取扱いについて</SubHeading>
                    <SubHeading>利用目的について</SubHeading>
                    <Paragraph>
                        当社は、適法かつ公正な手段で個人情報を取得し、以下の表に示す「利用目的」の範囲内で利用します。
                        <br />
                        なお、「利用目的」の範囲に含まれていない利用目的が生じたときは、直接書面によって取得した場合はご本人へ利用目的について同意を得たうえで、それ以外の手段で取得した場合には利用目的を公表したうえで利用いたします。
                    </Paragraph>
                    <SecondStyledTable>
                        <thead>
                            <tr>
                                <th>対象情報</th>
                                <th>利用目的</th>
                                <th>保有個人情報</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>MAnyに登録に関わる個人情報</td>
                                <td rowSpan={3}>・本サービスの提供・利用のため</td>
                                <td>○</td>
                            </tr>
                            <tr>
                                <td>仲介会社様に関する個人情報</td>
                                <td>○</td>
                            </tr>
                            <tr>
                                <td>売り手企業に関する個人情報</td>

                                <td>○</td>
                            </tr>
                            <tr>
                                <td>サービスへのお問い合わせに関する個人情報</td>
                                <td>・お問い合わせに対するご案内のため</td>
                                <td>○</td>
                            </tr>
                            <tr>
                                <td>苦情及び相談に関する個人情報</td>
                                <td>・苦情及び相談への回答のため</td>
                                <td>○</td>
                            </tr>
                        </tbody>
                    </SecondStyledTable>
                </Section>

                <Section>
                    <SubHeading>匿名加工情報について</SubHeading>
                    <Paragraph>
                        当社は、特定の個人を識別することおよび作成に用いる個人情報を復元することができないよう適切な保護措置を講じたうえで、匿名加工情報の作成と第三者への提供を法令で定められた範囲で実施します。
                    </Paragraph>
                    <StyledTable>
                        <tbody>
                            <tr>
                                <td>匿名加工情報に含まれる項目</td>
                                <td>住所、年齢</td>
                            </tr>
                            <tr>
                                <td>匿名加工情報の提供の方法</td>
                                <td>データファイルを暗号化し、セキュリティ措置が適切に講じられた方法で提供</td>
                            </tr>
                        </tbody>
                    </StyledTable>
                </Section>
                <Section>
                    <SubHeading>安全管理措置について</SubHeading>
                    <Paragraph>
                        当社は、個人情報の漏えい、滅失又は毀損などのおそれに対して、以下の安全対策を講じます。
                    </Paragraph>
                </Section>
                <Section>
                    <SubHeading>組織的安全管理措置</SubHeading>
                    <Paragraph>
                        ・取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人情報の取扱いに関する規程を策定。
                        <br />
                        ・個人情報の取扱状況について、定期的な監査を実施。
                    </Paragraph>
                </Section>
                <Section>
                    <SubHeading>人的安全管理措置</SubHeading>
                    <Paragraph>・従業者に個人情報の取扱いに関する定期的な研修を実施。</Paragraph>
                </Section>
                <Section>
                    <SubHeading>物理的安全管理措置</SubHeading>
                    <Paragraph>
                        ・個人情報を取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人情報の閲覧を防止する措置を実施。
                        <br />
                        ・個人情報を取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、社内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、機器の暗号化又はパスワード制御を実施。
                    </Paragraph>
                </Section>
                <Section>
                    <SubHeading>技術的安全管理措置</SubHeading>
                    <Paragraph>
                        ・アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定。
                        <br />
                        ・個人情報を取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入。
                    </Paragraph>
                </Section>
                <Section>
                    <SubHeading>外的環境の把握</SubHeading>
                    <Paragraph>
                        •
                        個人情報を保管している以下の国における個人情報の保護に関する制度を把握した上で安全管理措置を実施。
                    </Paragraph>
                </Section>
                <Section>
                    <SubHeading>保有個人データの保管国</SubHeading>
                    <Paragraph>• 日本</Paragraph>
                </Section>
            </Container>
            <TopFooter />
        </>
    );
};
